import api from '../lib/api';
import type { Paginated } from '../types';
import type { Operator, OperatorInput } from '../types/crm';

// The single-record endpoints (show/create/update) return a JSON:API-style
// envelope: `{ data: { id, type, attributes: {...flat record...} } }`. List
// endpoints return flat records directly inside `data`. This matches the
// existing accounting serializer convention (see commission-entry.service.ts).

export const operatorService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Operator>> => {
    const response = await api.get<Paginated<Operator>>('/operators', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Operator> => {
    const response = await api.get<{ data: { attributes: Operator } }>(`/operators/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: OperatorInput): Promise<Operator> => {
    const response = await api.post<{ data: { attributes: Operator } }>('/operators', { operator: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<OperatorInput>): Promise<Operator> => {
    const response = await api.patch<{ data: { attributes: Operator } }>(`/operators/${id}`, { operator: data });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/operators/${id}`);
  },
};

export default operatorService;
